import React, { useEffect, useState } from "react";
import { AssetReturnRequestList } from "../../services/AssetService";
import { format } from "date-fns";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import AssetReturnRequestActionModal from "../Asset/ActionModal/AssetReturnRequestActionModal";
import { Link } from "react-router-dom";
import Pagination from "../Constant/Pagination";
import { Spinner } from "react-bootstrap";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import { CustomTooltip } from "../../components/CustomTooltip";
const AssetReturnRequest = () => {
  const [selectedData, setselectedData] = useState(null);
  const [actionType, setActionType] = useState("");
  const [returnActionModal, setReturnActionModal] = useState(false);
  const [loading, setLoaing] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });
  const handleToggleReturnActionModal = () => {
    setReturnActionModal(!returnActionModal);
  };
  const getRequestList = () => {
    setLoaing(true);
    AssetReturnRequestList(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoaing(false);
      });
  };
  useEffect(() => {
    getRequestList();
  }, [param]);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleAfterReturnActionSubmit = () => {
    handleToggleReturnActionModal();
    getRequestList();
  };
  return (
    <>
      <div className="mb-3">
        <h2 className="text-primary">Assets Return Requests</h2>
        <ol className="breadcrumb breadcrumb-arrow mb-0">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active">Return Requests</li>
        </ol>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="flex-fill flex-md-grow-0">
            <small>Search here</small>
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>
        <div>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-4">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Asset ID</th>
                    <th>Name</th>
                    <th>Brand</th>
                    <th>Return By</th>
                    <th>Reason</th>
                    <th>Return Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((asset, index) => (
                    <tr key={index}>
                      <td>
                        <Link
                          to={`/asset/${asset?.asset?.id}/basic-details`}
                          className="fw-bold text-primary"
                        >
                          {asset?.asset?.manual_asset_id || "-"}
                        </Link>
                      </td>
                      <td>{asset?.asset?.name || "-"}</td>
                      <td>{asset?.asset?.brand || "-"}</td>
                      <td>{asset?.return_by?.fullname || "-"}</td>
                      <td>{asset?.return_reason || "-"}</td>
                      <td>
                        {asset?.return_at
                          ? format(new Date(asset.return_at), "dd MMM yyyy")
                          : "-"}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <CustomTooltip title="Accept" placement="top">
                            <span
                              className="btn btn-sm btn-outline-light text-info rounded-2"
                              style={{ padding: "0.3rem" }}
                              onClick={() => {
                                setActionType("accept");
                                setselectedData(asset);
                                handleToggleReturnActionModal();
                              }}
                            >
                              <IoIosCheckmarkCircle
                                className="text-success"
                                size={19}
                              />
                            </span>
                          </CustomTooltip>

                          <CustomTooltip title="Reject" placement="top">
                            <span
                              className="btn btn-sm btn-outline-light text-danger rounded-2"
                              style={{ padding: "0.3rem" }}
                              onClick={() => {
                                setActionType("reject");
                                setselectedData(asset);
                                handleToggleReturnActionModal();
                              }}
                            >
                              <MdCancel className="text-danger" size={19} />
                            </span>
                          </CustomTooltip>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">
              <span>No data found</span>
            </div>
          )}

          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      <AssetReturnRequestActionModal
        actionType={actionType}
        open={returnActionModal}
        onClose={handleToggleReturnActionModal}
        afterSubmit={handleAfterReturnActionSubmit}
        assetData={selectedData}
      />
    </>
  );
};

export default AssetReturnRequest;
